import Wrapper from 'components/Wrapper/Wrapper'
import Text from 'components/common/BaseText/BaseText'
import Project from './Project/Project'

import SimpleShopProductPageImg from '../../../assets/so-simple-shop-product-page.png'
import CRMDashboardImg from '../../../assets/crm-dashboard.png'
import MyOwnPageImg from '../../../assets/my-own-page.png'

import './Projects.scss'

const Projects: React.FC = () => {
	return (
		<Wrapper className='projects' id='projects'>
			<div className='projects__container-title'>
				<h3 className='projects__title'>My projects</h3>
				<span className='projects__subtitle'>
					As a front-end developer, I focus on the finer details, guaranteeing that every project I tackle showcases
					top-notch code quality and delivers an extraordinary user experience that captivates and engages the audience.
				</span>
			</div>

			<Project
				img={SimpleShopProductPageImg}
				text='Elegant website for an online store with a minimalist and visually appealing design. Has been developed
						following good practices, incorporating a mobile-first approach and adhering to the principles of Responsive
						Web Design (RWD).'
				tags={['Next.js', 'CSS', 'MongoDB', 'Swiper', 'Vercel']}
			/>

			<Project
				img={CRMDashboardImg}
				text='CRM (Customer Relationship Management) application with authentication using Firebase, as a way to showcase
				my skills in Vue.js. This application is currently in the development phase, indicating that it is still
				being worked on and not yet in its final, fully functional state.'
				tags={['Vue.js', 'Pinia', 'CSS', 'Firebase', 'Vitest', 'Cypress', 'Netlify']}
			/>

			<Project
				img={MyOwnPageImg}
				text='My personal website, developed with React. It features a minimalist and visually appealing design,
				incorporating a mobile-first approach and adhering to the principles of Responsive Web Design (RWD). With a
				focus on good practices, this website highlights my expertise in creating engaging and user-friendly
				experiences.'
				tags={['React', 'Typescript', 'MaterialUI', 'SCSS', 'Jest', 'Swiper', 'Netlify']}
			/>
		</Wrapper>
	)
}

export default Projects
